/*
  A close button shoppers can see on FlexyPe's sign-up pop-up.

  The pop-up is dialog#flexy-pass in our page, holding one frame served from
  pass.flexype.in. FlexyPe's own cross is drawn inside that frame, white on a
  near-white card (contrast about 1:1), and a frame from another site cannot be
  restyled from the theme. The dialog box is exactly the frame's box, so a button
  placed in the dialog's top-right corner sits over FlexyPe's cross.

  A tap closes the pop-up the way FlexyPe does (window.closeFlexyPass removes its
  page scroll lock and records the close); FlexyPe opens it once per visit, so it
  does not come back. Escape closes it too while focus is in our page.
*/
(function () {
  var ID = 'flexy-pass';

  function close() {
    if (typeof window.closeFlexyPass === 'function') {
      window.closeFlexyPass();
    } else {
      var d = document.getElementById(ID);
      if (d && d.open) d.close();
      document.documentElement.style.overflow = '';
    }
  }

  function addStyle() {
    if (document.getElementById('ew-fp-close-style')) return;
    var s = document.createElement('style');
    s.id = 'ew-fp-close-style';
    s.textContent =
      '#' + ID + ' .ew-fp-close{position:absolute;top:12px;right:12px;z-index:2;width:36px;height:36px;margin:0;padding:0;border:0;border-radius:50%;' +
      'display:flex;align-items:center;justify-content:center;background:#1e1e1e;box-shadow:0 1px 4px rgba(0,0,0,.25);cursor:pointer;-webkit-tap-highlight-color:transparent}' +
      '#' + ID + ' .ew-fp-close::before{content:"";position:absolute;inset:-4px;border-radius:50%}' +
      '#' + ID + ' .ew-fp-close:focus-visible{outline:2px solid #1e1e1e;outline-offset:3px}' +
      '#' + ID + ' .ew-fp-close svg{display:block;pointer-events:none}';
    document.head.appendChild(s);
  }

  function addButton(d) {
    if (d.querySelector('.ew-fp-close')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ew-fp-close';
    b.setAttribute('aria-label', 'Close');
    b.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
    b.addEventListener('click', close);
    d.appendChild(b);
  }

  function watch(d) {
    addStyle();
    addButton(d);
    // FlexyPe may rebuild the dialog's content when it opens: put the button back if it goes.
    new MutationObserver(function () { addButton(d); }).observe(d, { childList: true, attributes: true, attributeFilter: ['open'] });
  }

  function start() {
    var d = document.getElementById(ID);
    if (d) { watch(d); return; }
    var mo = new MutationObserver(function () {
      var found = document.getElementById(ID);
      if (found) { mo.disconnect(); watch(found); }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.getElementById(ID);
    if (d && d.open) close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
